import { ForecastPromo } from '../components/surf-forecast/surf-forecast.component'
import React, { Suspense, useRef } from 'react'
import { useRouter } from 'next/router'
// Sanity
import { getClient } from '../client'
import { propsSanity, groqSanityPageQuery } from '../lib/libFunctions'

// Styles
import { base } from '../styles/base/_allBase.styles'
const {
  GridItem_HeaderSection,
  GridContainer_Page_Layout,
  Page_Main_Grid_Container,
} = base
// Components
import SEO from '../components/seo-head/seo-head'
import SectionOne from '../components/section-one/section-one.jsx'
import { SurfGuideIntro } from '../components/surf-planning/surf-planning.component'
import { surfGuideSeo } from '../lib/surf-seo.mjs'
import { Header } from '../components/header/header'
import { Footer } from '../components/footer/footer.component.jsx'
import AccommodationGridSection from '../components/accommodationGridSection/AccommodationGridSection'

function Home(props) {
  const sectionOneRef = useRef()
  const router = useRouter()

  const {
    header,
    headerTwoColumnText,
    whereToStay,
  } = props.data.data
  const { seo } = props.data
  const surfHeader = { ...header, header: 'Selong Belanak Surf Guide & Beaches' }

  return (
    <GridContainer_Page_Layout>
      <SEO seo={surfGuideSeo(seo)} router={router} header={surfHeader} />
      <GridItem_HeaderSection>
        <header ref={sectionOneRef}>
          <Header />
        </header>
      </GridItem_HeaderSection>
      <main>
        <Page_Main_Grid_Container>
          <Suspense fallback={<div>Loading...</div>}>
            <SectionOne header={surfHeader} />
            <SurfGuideIntro module={headerTwoColumnText} />
            <ForecastPromo placement="beaches-surfing" />
            <AccommodationGridSection
              module={whereToStay}
              accommodations={whereToStay?.accommodations || []}
            />
          </Suspense>
          <Footer />
        </Page_Main_Grid_Container>
      </main>
    </GridContainer_Page_Layout>
  )
}

export async function getServerSideProps() {
  const query = groqSanityPageQuery('beaches-surfing')
  const data = await getClient().fetch(query, {})

  return {
    props: {
      data: propsSanity(data),
    },
  }
}

export default Home
